import Workshops from "../register/Workshops.svelte";
import Login from "../Login.svelte";
import Pay from "../register/Pay.svelte";
import Thankyou from "../register/Thankyou.svelte";
import Home from "../Home.svelte";
import Dashboard from "../register/Dashboard.svelte";
import WorkshopDetail from "../register/WorkshopDetail.svelte";
import WorkshopHome from "../lms/WorkshopHome.svelte";
import LessonWrapper from "../lms/LessonWrapper.svelte";
import Authenticate from "../register/Authenticate.svelte";
import { get } from "svelte/store";
import {
  user,
  transitionString,
  flowData,
  pageStack,
  appMode,
} from "./stores.js";
import {
  userWorkshopsUnsub,
  activeWorkshopUnsub,
  openWorkshopsUnsub,
} from "./firebase";

class Page {
  sveltePage;
  constructor(props) {
    props = {
      skipCheck: (props) => {
        return false;
      }, // function that returns boolean
      ...props,
    };
    this.sveltePage = props.sveltePage;
    this.skipCheck = props.skipCheck;
    this.appMode = props.appMode;
  }
  get skip() {
    return this.skipCheck({
      user: get(user),
    });
  }
}

export const pages = {
  workshops: new Page({
    sveltePage: Workshops,
    appMode: "register",
  }),
  login: new Page({
    sveltePage: Login,
    skipCheck: (props) => {
      return props.user.loggedIn;
    },
    appMode: "register",
  }),
  pay: new Page({
    sveltePage: Pay,
    skipCheck: (props) => {
      return false;
    },
    appMode: "register",
  }),
  thankYou: new Page({
    sveltePage: Thankyou,
    skipCheck: (props) => {
      return !props.user.loggedIn;
    },
    appMode: "register",
  }),
  home: new Page({
    sveltePage: Home,
    appMode: "register",
  }),
  dashboard: new Page({
    sveltePage: Dashboard,
    skipCheck: (props) => {
      return !props.user.loggedIn;
    },
    appMode: "register",
  }),
  workshopDetail: new Page({
    sveltePage: WorkshopDetail,
    appMode: "register",
  }),
  workshopHome: new Page({
    sveltePage: WorkshopHome,
    appMode: "lms",
  }),
  lessonWrapper: new Page({
    sveltePage: LessonWrapper,
    appMode: "lms",
  }),
  authenticate: new Page({
    sveltePage: Authenticate,
    appMode: "register",
  }),
};

let openWorkshopsUnsubLocal, userWorkshopsUnsubLocal, activeWorkshopUnsubLocal;

export const updateSubs = (loggedIn, appModeLocal) => {
  console.log("in updateSubs");
  console.log(`loggedIn: ${loggedIn}, appMode: ${appModeLocal}`);

  console.log(userWorkshopsUnsubLocal);
  if (userWorkshopsUnsubLocal) {
    if (!loggedIn || appModeLocal != "register") {
      console.log("unsubbing userWorkshops");
      userWorkshopsUnsubLocal();
      userWorkshopsUnsubLocal = undefined;
    }
  } else {
    if (loggedIn && appModeLocal == "register") {
      console.log("subbing userWorkshops");
      userWorkshopsUnsubLocal = userWorkshopsUnsub();
    }
  }

  console.log(activeWorkshopUnsubLocal);
  if (activeWorkshopUnsubLocal) {
    if (!loggedIn || appModeLocal != "lms") {
      console.log("unsubbing activeWorkshop");
      activeWorkshopUnsubLocal();
      activeWorkshopUnsubLocal = undefined;
    }
  } else {
    if (appModeLocal == "lms") {
      console.log("subbing activeWorkshop");
      activeWorkshopUnsubLocal = activeWorkshopUnsub();
    }
  }

  console.log(openWorkshopsUnsubLocal);
  if (openWorkshopsUnsubLocal) {
    if (appModeLocal != "register") {
      console.log("unsubbing openWorkshops");
      openWorkshopsUnsubLocal();
      openWorkshopsUnsubLocal = undefined;
    }
  } else {
    if (appModeLocal == "register") {
      console.log("subbing openWorkshops");
      openWorkshopsUnsubLocal = openWorkshopsUnsub();
    }
  }
};

const transitionMap = {
  forward: {
    in: { y: 400, duration: 300, delay: 100 },
    out: { y: -400, duration: 300 },
  },
  back: {
    in: { y: -400, duration: 300, delay: 100 },
    out: { y: 400, duration: 300 },
  },
};

export const updateComponent = (pageToLoadString) => {
  let transition = transitionMap[get(transitionString)];

  let pageToLoadLocal = pages[pageToLoadString];

  while (pageToLoadLocal.skip) {
    console.log("loop time around");
    pageToLoadLocal = pages[get(flowData).loginDestination];
  }

  console.log(`loading`);
  console.log(pageToLoadLocal);

  pageStack.update((m) => {
    m.push(pageToLoadString);
    return m;
  });

  transitionString.set("forward");

  console.log(`Setting appMode to ${pageToLoadLocal.appMode}`);

  let modeChange = false;
  appMode.update((n) => {
    if (n != pageToLoadLocal.appMode) {
      modeChange = true;
    }
    return pageToLoadLocal.appMode;
  });

  console.log(get(appMode));

  return {
    transition: transition,
    curComponent: pageToLoadLocal.sveltePage,
    modeChange: modeChange,
  };
};
